import React from "react";
import "./StoreRibbonTag.css";

const StoreRibbonTag = ({
  label,
  background = "#148e00",
  color = "#ffffff",
}) => {
  if (!label) return null;

  return (
    <span
      className="store-ribbon-tag"
      style={{
        "--ribbon-bg": background,
        "--ribbon-color": color,
      }}
    >
      <svg
        className="store-ribbon-tag__shape"
        viewBox="0 0 142.523 25.2252"
        preserveAspectRatio="none"
        aria-hidden="true"
      >
        <path d="M0 0H142.523L132.656 13.0631L142.523 25.2252H0V0Z" />
      </svg>
      <span className="store-ribbon-tag__label">{label}</span>
    </span>
  );
};

export default StoreRibbonTag;
